import {
  buildInstrumentResponsePresentation,
  formatInstrumentResponseUnit,
} from '../../../utils/instrumentResponsePresentation';

export default function SessionResponseDisplay({ response, role = 'participant' }) {
  const presentation = buildInstrumentResponsePresentation(response);

  if (presentation.kind !== 'normalized') {
    return <p>Unsupported normalized session response.</p>;
  }

  return (
    <section aria-label={`${role} direct response`}>
      <p><strong>{role === 'consensus' ? 'Direct facilitator consensus response' : 'Direct participant response'}</strong></p>
      <p>{presentation.protocolKey} · {presentation.protocolVersion || 'version unknown'}</p>
      <dl>
        {presentation.units.map(unit => (
          <div key={unit.key}>
            <dt>{unit.label}</dt>
            <dd>{formatInstrumentResponseUnit(unit)}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}

export function DerivedAggregateReference({ aggregate }) {
  if (!aggregate || aggregate.responseRole !== 'derivedAggregate') return null;

  return (
    <aside className="warning-message" aria-label="Derived aggregate reference">
      <strong>Derived aggregate reference — not consensus</strong>
      {aggregate.status === 'calculated' ? (
        <ul>
          {Object.entries(aggregate.units || {}).map(([key, unit]) => (
            <li key={key}>{key}: {unit.value}/100 ({unit.observationCount} participant responses)</li>
          ))}
        </ul>
      ) : (
        <p>{aggregate.message || 'A compatible aggregate is unavailable.'}</p>
      )}
    </aside>
  );
}
